import { AnimatePresence, motion } from 'framer-motion';
import { Download, X, Share, PlusSquare } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { usePwaInstall } from '@/hooks/use-pwa-install';

export function PwaInstallPrompt() {
    const { isInstallable, isInstalled, isIOS, installApp } = usePwaInstall();
    const [isVisible, setIsVisible] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        // Show if it's installable OR if it's iOS (since iOS doesn't fire the event)
        // But only if it's not already installed and user hasn't dismissed it
        if (!isInstalled && !dismissed) {
            // Slight delay so it doesn't pop up immediately on first load
            const timer = setTimeout(() => {
                if (isInstallable || isIOS) {
                    setIsVisible(true);
                }
            }, 3000);

            return () => clearTimeout(timer);
        } else {
            setIsVisible(false);
        }
    }, [isInstallable, isInstalled, isIOS, dismissed]);

    const handleDismiss = () => {
        setIsVisible(false);
        setDismissed(true);
        // Optionally save to localStorage to never show again for 7 days
        // localStorage.setItem('pwa-prompt-dismissed', Date.now().toString());
    };

    if (!isVisible) {
return null;
}

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className="fixed bottom-28 left-4 right-4 z-50 md:left-auto md:right-4 md:w-[400px] lg:bottom-4"
                >
                    <div className="relative overflow-hidden rounded-[2.5rem] bg-white/95 p-6 shadow-[0_20px_50px_rgba(0,0,0,0.15)] backdrop-blur-xl border border-black/5">
                        {/* Decorative subtle accent */}
                        <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-emerald-500/5 blur-2xl" />

                        <div className="relative z-10 space-y-5">
                            <div className="flex items-start justify-between">
                                <div className="flex items-center gap-4">
                                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[1.25rem] bg-gradient-to-br from-[#006944] to-[#004d32] text-[#ffd709] shadow-lg shadow-emerald-900/10">
                                        <Download className="h-7 w-7" strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-black tracking-tight text-[#003628]">My ASWAJA</h3>
                                        <p className="text-[10px] font-black tracking-widest text-[#306554]/40 uppercase">Akses lebih mudah</p>
                                    </div>
                                </div>
                                <button
                                    onClick={handleDismiss}
                                    className="rounded-full bg-slate-50 p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
                                >
                                    <X className="h-5 w-5" strokeWidth={1.5} />
                                </button>
                            </div>

                            <p className="text-sm font-medium leading-relaxed text-[#306554]/80">
                                Install aplikasi untuk akses lebih cepat dan pengalaman terbaik di perangkat Anda.
                            </p>

                            {isIOS && !isInstallable ? (
                                <div className="rounded-2xl bg-slate-50/50 p-4 border border-black/[0.02]">
                                    <p className="text-[11px] font-medium leading-relaxed text-[#306554]">
                                        Tap icon <span className="inline-flex items-center justify-center rounded-lg bg-white p-1 text-blue-500 shadow-sm mx-0.5"><Share className="h-3 w-3" /></span> lalu pilih <strong className="font-black">Add to Home Screen</strong> <span className="inline-flex items-center justify-center rounded-lg bg-white p-1 shadow-sm mx-0.5"><PlusSquare className="h-3 w-3 text-gray-700" /></span>.
                                    </p>
                                </div>
                            ) : (
                                <button
                                    onClick={installApp}
                                    className="group relative flex w-full items-center justify-center gap-3 overflow-hidden rounded-2xl bg-[#ffd709] py-4 transition-all active:scale-95 shadow-lg shadow-yellow-200"
                                >
                                    <div className="absolute inset-0 bg-white/20 translate-y-full transition-transform group-hover:translate-y-0" />
                                    <Download className="relative z-10 h-5 w-5 text-[#5b4b00]" strokeWidth={2} />
                                    <span className="relative z-10 text-[11px] font-black tracking-[0.2em] text-[#5b4b00] uppercase">
                                        Install Sekarang
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
